Controller.$inject = [];

function Controller() {
    let self = this;

    self.$postLink = () => {
        let color, icon;
        switch (self.type) {
            case 'success':
                color = 'success';
                icon = self.icon || 'fa-circle-check';
                break;
            case 'warning':
                color = 'warning';
                icon = self.icon || 'fa-triangle-exclamation';
                break;
            case 'danger':
            case 'error':
                color = 'danger';
                icon = self.icon || 'fa-circle-xmark';
                break;
            case 'primary':
                color = 'primary';
                icon = self.icon || 'fa-ban';
                break;
            case 'info':
                color = 'info';
                icon = self.icon || 'fa-info-circle';
                break;
        }

        self.toastMapping = {color, icon};
    };
}

export function HuiToast() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: Controller,
        bindToController: {
            description: '@',
            title: '@',
            type: '@',
            icon: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="h-message hui-toast before hui-{{$huiCtrl.toastMapping.color}}">
                    <div class="msg-content">
                        <div class="msg-icon">
                            <i class="fa-solid {{ $huiCtrl.toastMapping.icon }} text-white"></i>
                        </div>
                        <div class="msg-body">
                            <div class="msg-title" ng-if="$huiCtrl.title">{{ $huiCtrl.title }}</div>
                            <div class="msg-desc">
                                {{ $huiCtrl.description }}
                            </div>
                        </div>
                        <span class="close-btn" aria-hidden="true" automation="sideNotificationCloseButton">&times;</span>
                    </div>
                </div>
            `;
        }
    };
}
